<div *ngIf="toggled && showMinimize" class="jmCollapseTitleLearnMore">
	<div class="jmPageTitle" style="padding-top: 10px;">
		{{title}}
		<div (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square"></div>
	</div>
</div>

<div id="{{objectIdForCollapsingWidget}}" *ngIf="!toggled" [hidden]="toggled" class="jmWidgetPadding">
	<div class="w-100" style="height:6%">
		<div class="jmPageTitle" style="padding-bottom: 10px;">
			{{title}}
			<div (click)="toggleCollapse()" *ngIf="showMinimize" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="right: 0px; margin-top:10px;"></div>
		</div>
	</div>
	<div class="row">
		<div [ngClass]="(lgView===true)?'col-6':'col-12'" style="text-align:center;">
			<div class="section-heading-wrapper earn-section-wrapper">
				<span>Percentage Earning Above High School Grad</span>
				<i class="jmInfoCircle" style="margin-left:5px;" (click)="displayInfoWrapper('Percentage Earning Above High School Grad','The share of former students earning more than $25,000, or about the average earnings of a high school graduate aged 25-34, 6 years after they first enroll.', 'earning')"></i>
			</div>
			<div style="margin-bottom:15px; color:#56dcc4; font-weight:bold; text-align:center;">{{data.AboveHighSchoolGradPcnt}}%</div>
			<div>of students who attend this school earned, on average, more than those with only a high school diploma.</div>
		</div>
		<div [ngClass]="(lgView===true)?'col-6':'col-12'" style="text-align:center;">
			<div class="section-heading-wrapper earn-section-wrapper">
				<span class="section-heading">Salary After Attending</span>
				<i class="jmInfoCircle" (click)="displayInfoWrapper('Salary After Attending','The median earnings of former students who received federal financial aid, at 10 years after entering the school.', 'salary')"></i>
			</div>
			<figure class="meter" style="margin-bottom:15px;">
				<picc-meter [attr.max]="data.Max" [attr.average]="data.Average" [attr.national-average]="data.NationalAverage">
					<div class="picc-meter-bar" [ngStyle]="{'height':data.AveragePcnt+'%'}"></div>
					<div class="picc-meter-line" [ngStyle]="{'bottom':data.NationalAveragePcnt+'%'}"><span class="label">${{appUtility.toCommaNumber(data.NationalAverage)}}</span></div>
				</picc-meter>
				<figcaption><span *ngIf="data.Average>0">${{appUtility.toCommaNumber(data.Average)}}</span><span *ngIf="data.Average==0">Data not available</span></figcaption>
			</figure>
			<div style="margin-bottom:10px;">---- National Average</div>
		</div>
	</div>
</div>
